import React from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import ContactForm from '../components/sections/ContactForm';

const PageBanner = styled.section`
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)), url('/images/gautier-pfeiffer-WPapb9IqRKw-unsplash.jpg');
  background-size: cover;
  background-position: center;
  padding: 120px 0 80px;
  text-align: center;
  color: #fff;
  
  h1 {
    font-size: 3rem;
    font-weight: 800;
    margin-bottom: 20px;
    
    span {
      color: #ff9800;
    }
    
    @media (max-width: 768px) {
      font-size: 2.3rem;
    }
  }
  
  p {
    font-size: 1.2rem;
    max-width: 700px;
    margin: 0 auto 30px;
    
    @media (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
  
  .steps-container {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-top: 40px;
    
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 20px;
    }
    
    .step {
      text-align: center;
      
      .step-number {
        width: 50px;
        height: 50px;
        background: #ff9800;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 1.5rem;
        margin: 0 auto 15px;
      }
      
      .step-text {
        font-weight: 600;
      }
    }
  }
`;

const GetOffer = () => {
  return (
    <>
      <PageBanner>
        <Container>
          <h1>Get Your <span>Cash Offer</span></h1>
          <p>
            Complete the form below to receive a fair cash offer for your land. 
            We buy all types of land properties throughout the United States.
          </p>
          
          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-text">Submit Your Info</div>
            </div>
            
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-text">Get Your Offer</div>
            </div>
            
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-text">Get Paid</div>
            </div>
          </div>
        </Container>
      </PageBanner>
      
      <ContactForm />
    </>
  );
};

export default GetOffer;
